<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-btn small icon flat slot="activator">
        <v-icon color="accent">edit</v-icon>
      </v-btn>
      <v-card>
        <v-card-title>
          <span class="title font-weight pl-1">Create User Task</span>
          <v-spacer />
          <v-btn flat icon large @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-form ref="taskForm" v-model="validForm">
              <v-layout wrap>
                <v-flex xs12>
                  <v-text-field
                    autofocus
                    label="Task name*"
                    required
                    box
                    v-model="taskNameData"
                    :rules="required"
                    color="secondary"
                    clearable
                  />
                </v-flex>
                <v-flex xs12>
                  <v-autocomplete
                    :loading="camundaUsersUpdating"
                    :outline="$vuetify.dark"
                    color="secondary"
                    v-model="taskAssignee"
                    :items="camundaUserIds"
                    :rules="required"
                    label="Task Assignee"
                    clearable
                  >
                    <template slot="selection" slot-scope="data">
                      <v-chip
                        :key="JSON.stringify(data.item)"
                        :selected="data.selected"
                        :disabled="data.disabled"
                        class="v-chip--select-multi"
                        @input="assignee = ''"
                        close
                      >
                        <v-avatar
                          class="secondary"
                          v-text="data.item.slice(0, 1).toUpperCase()"
                        />
                        {{ data.item }}
                      </v-chip>
                    </template>
                  </v-autocomplete>
                </v-flex>
                <v-flex xs12>
                  <v-textarea
                    name="input-description-1"
                    box
                    color="secondary"
                    label="Task Description*"
                    auto-grow
                    required
                    v-model="taskDescription"
                    :rules="required"
                    clearable
                  />
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
          <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
          <v-layout align-center justify-end>
            <v-btn
              class="text-capitalize secondary"
              :class="!$vuetify.dark ? 'secondary' : ''"
              :outline="$vuetify.dark"
              flat
              @click="createUserTask"
            >
              Save
            </v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'CreateUserTask',
  props: {
    taskName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      dialog: false,
      taskAssignee: '',
      taskNameData: '',
      taskDescription: null,
      candidateUsers: [],
      camundaUsersUpdating: false,
      validForm: false,
      required: [v => !!v || 'Field is required']
    }
  },

  mounted() {
    this.getCamundaUsers()
    this.taskNameData = this.taskName
  },

  computed: {
    ...mapState({
      camundaSupportUsers: state => state.camunda.camundaSupportUsers
    }),
    camundaUserIds() {
      return this.camundaSupportUsers.map(a => a.id)
    }
  },

  methods: {
    async getCamundaUsers() {
      this.camundaUsersUpdating = true
      try {
        await this.$store.dispatch('fetchSupportUsers')
      } catch (e) {
        await this.$store.dispatch('directNotification', {
          type: 'error',
          message: 'Sync up issues, Kindly check with the Administrator',
          description: e.response
            ? e.response.data.message
            : 'Error unknown! Kindly retry',
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
        })
      }
      this.camundaUsersUpdating = false
    },
    async createUserTask() {
      if (this.$refs.taskForm.validate()) {
        let task = {}
        task.name = this.taskNameData
        task.description = this.taskDescription
        task.assignee = this.taskAssignee
        let _self = this
        await this.$store.dispatch('createSupportTask', task)
        _self.onAfterSave()
        _self.dialog = false
        await this.$store.dispatch('directNotification', {
          timestamp: moment().format('DD MMM YYYY hh:mm:ss a'),
          message: 'Task has been Created',
          description: 'User Task created Successfully',
          type: 'success'
        })
      }
    },
    onAfterSave: function() {
      this.$emit('AfterSave')
    }
  }
}
</script>

<style scoped></style>
